import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";

function CustomDropdown({ options, selectedValue, onChange, className }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (value) => {
    onChange(value);
    setIsOpen(false);
  };

  return (
    <div className={`relative ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 rounded-full border text-sm font-medium transition-all duration-150 bg-grayish text-main1 hover:bg-main1/10"
      >
        {options.find((o) => o.value === selectedValue)?.label}
        <FaChevronDown className={`transition-transform ${isOpen ? "rotate-180" : ""}`} />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-44 bg-light rounded-xl shadow-lg border border-gray-200 overflow-hidden z-10">
          {options.map((o) => (
            <div
              key={o.value}
              onClick={() => handleSelect(o.value)}
              className={`px-4 py-2 text-sm cursor-pointer transition ${selectedValue === o.value ? "bg-main1 text-light" : "hover:bg-grayish/50 text-main1"}`}
            >
              {o.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default CustomDropdown;
